import { Component, OnInit , ViewChild,ChangeDetectorRef} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router, ActivatedRoute } from '@angular/router';
import { PageEvent } from '@angular/material/paginator';
import { TableService } from '../services/pager/pager';
import { WebService } from '../services/web/web.service';
import { SpinnerService } from '../services/spinner/spinner.service';
import { ToastService } from '../services/notification/toast.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CreateCardPopupComponent } from './create-card-popup/create-card-popup.component';
import { AppConfirmService } from '../app-confirm/app-confirm.service';
import { forkJoin, of, Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { UserPermissionsService } from '../services/user-permissions.service';
import { BillingAddress } from '../models/billing-address.model';
import { formatAddressDetail, formatCardExpiration } from '../shared/utils/card-display.util';
// import { HasplanFilter } from './hasplan.filter';

interface CardDetailsResult {
  tdc: any;
  parms: any;
  error?: any;
}

/** Ancho del diálogo de alta: dos columnas (tarjeta + dirección de facturación). */
const CREATE_CARD_DIALOG_WIDTH = '960px';

@Component({
    selector: 'app-customer-cards',
    templateUrl: './customer-cards.component.html',
    styleUrls: ['./customer-cards.component.scss'],
    providers: [AppConfirmService],
    standalone: false
})
export class CustomerCardsComponent implements OnInit {

  tarjetas : any;
  editar = false;
  estado = false;
  IDcustomer : any;
  confirm: boolean = false;
  res : any;
  items : any;

      // PARA MANEJO DE TABLAS
      @ViewChild(MatPaginator) paginator: MatPaginator | undefined;
      @ViewChild(MatSort) sort: MatSort | undefined;
      displayedColumns: string[] = ['maskCreditCard', 'expMonthCreditCard', 'expiration', 'nameHolderCreditCard', 'billingAddress', 'createdAt','actions'];
      dataSource: any;

    constructor(
      public  tableService: TableService<any>,
      private activatedRoute: ActivatedRoute,
      private router: Router,
      private dialog: MatDialog,
      private confirmService: AppConfirmService,
      private cdr: ChangeDetectorRef,private webService : WebService,private spinner : SpinnerService,private toast : ToastService,
      private translate: TranslateService,
      private userPermissionsService: UserPermissionsService) {
        this.tableService = new TableService;
      }

      ngOnInit() {
        this.getItems()
      }
  //
  // loadCreditCards() {
  //   this.web.get(this.web.HOST + '/creditcard/customer/' + this.auth.getCustomer()).subscribe(
  //       (params) => {
  //         console.log('Respuesta tarjetas backend:', params); // <-- LOG AÑADIDO
  //         if (params['result'] && params['result'].length > 0) {
  //           this.tarjetas = params['result'];
  //           this.tarjetas.forEach(tdc => {
  //             if(tdc.corerId != null ){
  //               this.web.get(this.web.HOST + '/customer/' + this.auth.getCustomer() + '/customerHasCreditCard/' + tdc.corerId).subscribe(response => {
  //                 tdc.estatus = response['result']['statusCreditCard'];
  //                 tdc.token = response['result']['tokenCreditCard'];
  //                 tdc.mask_card = tdc.mask_card.substr(tdc.mask_card.length - 8);
  //                 if(tdc.estatus == 1){
  //                   this.items.push({ expMonthCreditCard : tdc.expiration_month, expYearCreditCard : tdc.expiration_year , id: tdc.corerId, type: tdc.expMonthCreditCard, maskCreditCard: tdc.mask_card, estatus: tdc.estatus, token : tdc.token, nameHolderCreditCard : tdc.customer.name_customer });
  //                 }
  //                 this.dataSource.data = this.items;
  //                 this.dataSource.paginator = this.paginator;
  //                 this.loader.close();
  //               }, (err) => {
  //                 this.notification.showError(err);
  //                 this.loader.close();
  //               });
  //             }else{
  //               tdc.estatus = 0;
  //               this.items.push({ month : tdc.expiration_month, year : tdc.expiration_year , id: tdc.corerId, type: tdc.expMonthCreditCard, maskCreditCard: tdc.mask_card, estatus: tdc.estatus, token : tdc.token, nameHolderCreditCard : tdc.customer.name_customer });
  //               this.loader.close();
  //             }
  //           })
  //         } else {
  //           this.loader.close();
  //         }
  //       },
  //       (err) => {
  //         console.log(err);
  //         this.notification.showError(err);
  //         this.loader.close();
  //       }
  //   );
  // }

      ngOnDestroy() {
        // if (this.getItemSub) {
        //   this.getItemSub.unsubscribe()
        // }
      }

      getItems() {
        this.spinner.open();
        this.activatedRoute.params.subscribe(params => {
          this.IDcustomer = params["id"];
          
          this.items = [];
          this.webService.get(this.webService.HOST + '/creditcard/customer/' + encodeURIComponent(String(this.IDcustomer)) + '?excludePartnerGeo=true').subscribe(params => {
            console.log(params);
            if (params.result.length > 0) {
              this.tarjetas = params['result'];
              
              // Preparar las tarjetas con datos básicos
              const validCards = this.tarjetas.filter(tdc => tdc.corerId != null);
              
              if (validCards.length === 0) {
                this.spinner.close();
                this.toast.showInfo(this.translate.instant('customerCards.noActiveCards'));
                return;
              }

              // Mapeo de meses
              const mesesMap = {
                "01": "Enero", "02": "Febrero", "03": "Marzo", "04": "Abril",
                "05": "Mayo", "06": "Junio", "07": "Julio", "08": "Agosto",
                "09": "Septiembre", "10": "Octubre", "11": "Noviembre", "12": "Diciembre"
              };

              // Preparar datos básicos para cada tarjeta
              validCards.forEach(tdc => {
                tdc.expMonth = mesesMap[tdc.expiration_month] || tdc.expiration_month;
                tdc.expMonthCreditCard = tdc.creditCardProvider.description;
                
                if (tdc.mask_card != null) {
                  tdc.maskCreditCard = tdc.mask_card.substr(tdc.mask_card.length - 8);
                } else {
                  tdc.maskCreditCard = "XXXXXXXXXX";
                }
                
                tdc.expYearCreditCard = "20" + tdc.expiration_year;
                tdc.expiration = this.formatExpiration(tdc.expiration_month, tdc.expiration_year);
              });

              // Crear array de observables para llamadas paralelas
              const cardDetailsRequests: Observable<CardDetailsResult>[] = validCards.map(tdc => 
                this.webService.get(this.webService.HOST + "/customer/" + this.IDcustomer + "/customerHasCreditCard/" + tdc.corerId)
                  .pipe(
                    map(parms => ({ tdc, parms } as CardDetailsResult)),
                    catchError(err => {
                      console.error('Error fetching card details for corerId:', tdc.corerId, err);
                      return of({ tdc, parms: null, error: err } as CardDetailsResult);
                    })
                  )
              );

              // Ejecutar todas las llamadas en paralelo
              forkJoin(cardDetailsRequests).subscribe(
                (results: CardDetailsResult[]) => {
                  console.log('Parallel requests completed:', results);
                  
                  results.forEach((result: CardDetailsResult) => {
                    if (result.parms && result.parms['result'] && result.parms['result']['statusCreditCard'] == 1) {
                      result.tdc.statusInCorer = result.parms['result']['statusCreditCard'];
                      result.tdc.token = result.parms['result']['tokenCreditCard'];
                      result.tdc.nameHolderCreditCard = result.parms['result']['creditCard']['nameHolderCreditCard'];
                      this.items.push(result.tdc);
                    }
                  });

                  // Actualizar la tabla una sola vez con todos los datos
                  this.dataSource = new MatTableDataSource<any>(this.items);
                  this.spinner.close();
                  
                  if (this.items.length === 0) {
                    this.toast.showInfo(this.translate.instant('customerCards.noCardsFound'));
                  }
                },
                error => {
                  console.error('Error in parallel requests:', error);
                  this.spinner.close();
                  this.toast.showError(this.translate.instant('customerCards.errorLoadingCards'));
                }
              );
              
            } else {
              this.spinner.close();
              console.log("NO TDC");
              this.toast.showInfo(this.translate.instant('customerCards.noCardsAssociated'));
            }
          }, (err) => {
            this.spinner.close();
            console.log("ERRORRR");
            console.log(err);
            this.toast.showError(err);
          });
        });
      }

      openPopUp(data: any = {}, isNew? : any) {
        if (!this.canManageCreditCards()) {
          this.toast.showWarning('No tienes permisos para gestionar tarjetas.');
          return;
        }

        let title = isNew ? this.translate.instant('customerCards.addCard') : this.translate.instant('customerCards.editCard');
        let dialogRef: MatDialogRef<any> = this.dialog.open(CreateCardPopupComponent, {
          width: isNew ? CREATE_CARD_DIALOG_WIDTH : '720px',
          ...(isNew ? { maxWidth: '95vw' } : {}),
          maxHeight: '90vh',
          disableClose: true,
          data: { title: title, payload: data, customerId: this.IDcustomer }
        })
        dialogRef.afterClosed()
          .subscribe(res => {
            if(!res) {
              // If user press cancel
              return;
            }
            this.spinner.open();
            if (isNew) {
              this.res = res;
              this.add();
    
            } else {
        
              this.edit(res, data.id)
            
            }
          })
      }


      add(valorconf?: boolean){
        if (!this.canManageCreditCards()) {
          this.toast.showWarning('No tienes permisos para gestionar tarjetas.');
          return;
        }
      
        let obj = this.res;
        //Si no se ha dejado un campo vacio en el formulario para agregar TDCs
        if (obj.expMonthCreditCard != null && obj.expYearCreditCard != null &&
          obj.nameHolderCreditCard != null && obj.numberCreditCard != null) {
          //Se verifica el rango del mes y ano de vencimiento de la TDC
            if (this.verifyCCYearAndMonth(obj.expMonthCreditCard.toString(),obj.expYearCreditCard.toString())) {
  
              //Se verifica el numero de digitos de la TDC
              if (obj.numberCreditCard.toString().length >= 13 && obj.numberCreditCard.toString().length <= 19) {
  
                //Se verifica que el numero de la TDC cumpla con el algoritmo de Luhm
                if (this.valid_credit_card(obj.numberCreditCard.toString())) {
  
                  //En caso de que el numero de tarjeta (ultimos digitos) coincidan con una TDC previamente agregada, pedir confirmacion
                  if (!this.confirm) {
                    //Se busca en las tarjetas
                     for (let i in this.items) {
                      const last4Exist = this.items[i].maskCreditCard.substr(this.items[i].maskCreditCard.length-4);
                      const last4New = obj.numberCreditCard.toString().substr(obj.numberCreditCard.toString().length-4);
                      const monthExist = this.items[i].expiration_month;
                      const yearExist = this.items[i].expiration_year;
                      const monthNew = obj.expMonthCreditCard;
                      const yearNew = obj.expYearCreditCard;
                      //Si coinciden los ultimos 4 digitos y la fecha de vencimiento
                      if (
                        last4Exist === last4New &&
                        monthExist === monthNew &&
                        yearExist === yearNew
                      ) {
                        this.spinner.close();
                        this.toast.showError(this.translate.instant('customerCards.cardAlreadyExists'));
                        this.confirm = false;
                        return;
                      }
                    }
                    valorconf = true;
                  }
                  //Una vez confirmada (de ser necesaria una confirmacion, en caso contrario entra directamente)
                  if (valorconf) {
                    var creditcard : any = { "estatus":  "1", "numberCreditCard": obj.numberCreditCard.toString(), "nameHolderCreditCard" : obj.nameHolderCreditCard,"expMonthCreditCard": obj.expMonthCreditCard,"expYearCreditCard":  obj.expYearCreditCard};
                    if (obj.addressId != null) {
                      creditcard.addressId = obj.addressId;
                    }
                    this.webService.post(creditcard, this.webService.HOST + "/customer/" + this.IDcustomer + "/creditcard").subscribe(params => {
                      this.spinner.close();
                      if (params['message'] = "Successful created") {
                        this.toast.showSuccess(this.translate.instant('customerCards.cardCreated'));
                        //Se reinician los componentes visuales de la pantalla
                        this.ngOnInit();
                      }
                      else {
                        this.toast.showError(this.translate.instant('customerCards.cardNotCreated'));
                      }
                    }, err => {
                      this.spinner.close();
                      //En caso de error al no reconocer el proveedor de la TDC
                      if (err == "Credit card provider doesn't exist") {
                        this.toast.showError(this.translate.instant('customerCards.unknownProvider'));
                      }else{
                        this.toast.showError(this.translate.instant('customerCards.cardNotCreated'));
                      }
                    });
                  }
                 
                  this.confirm = false;
                }
                else {
                  this.spinner.close();
                  this.toast.showError(this.translate.instant('customerCards.invalidCardNumber'));
                }
              }
              else {
                this.spinner.close();
                this.toast.showError(this.translate.instant('customerCards.invalidDigits'));
              }
            }
            else {
              this.spinner.close();
              this.toast.showError(this.translate.instant('customerCards.invalidExpiration'));
            }
        } else {
          this.spinner.close();
          this.toast.showError(this.translate.instant('customerCards.allFieldsRequired'));
        }
    }

      edit(res: any, idedit : number){
        if (!this.canManageCreditCards()) {
          this.toast.showWarning('No tienes permisos para gestionar tarjetas.');
          return;
        }

        //Busca dentro de las TDC del customer
        this.webService.get(this.webService.HOST +"/customer/"+ this.IDcustomer + "/creditcard").subscribe(params => {
          if(params['result'] != null){
            let lastarjetas = params['result'];
            //Por cada tarjeta
            for(let i in lastarjetas){
              let latdc : any = lastarjetas[i].creditCard;
              //La tarjeta encontrada es la que se va a editar
              if(latdc.id == idedit) {
                latdc.nameHolderCreditCard = res.nameHolderCreditCard;
                //Se verifica que el nombre en la TDC no se encuentre vacio
                if (res.nameHolderCreditCard.toString().trim().length > 1) {
                  //Se actualiza la informacion de la tarjeta

                  let tdc = {"id": latdc.id, "nameHolderCreditCard" : latdc.nameHolderCreditCard,
                  "expMonthCreditCard" : latdc.expMonthCreditCard, "expYearCreditCard" : latdc.expYearCreditCard}
                  this.webService.put(tdc, this.webService.HOST +"/customer/"+ this.IDcustomer + "/creditcard" ).subscribe(params => {
                    if (params['message'] == 'Successful updated') {
                      this.toast.showSuccess(this.translate.instant('customerCards.cardUpdated'));
                      //Se actualizan los componentes de la pantalla
                      this.spinner.close();
                      this.editar = false;
                      this.ngOnInit();
                    }
                    else {
                      this.toast.showError(this.translate.instant('customerCards.cardNotUpdated'));
                    }
                  }, err => {
                    this.toast.showError(err)
                  });
                }else{
                  this.toast.showError(this.translate.instant('customerCards.nameRequired'));
                }
              }
            }
          }
        });
      }

          //Metodo que permite verificar el mes y ano de la TDC introducida
    verifyCCYearAndMonth(month : string, year: string) : boolean{
      //Verifica que el mes se encuentre entre 01 y 12
      if(1 < Number.parseInt(month) && Number.parseInt(month) > 12){
        return false;
      }
  
      //Verifica el limite inferior del ano de vencimiento
      if((Number.parseInt(month)-1) < new Date().getMonth()){
        if(Number.parseInt(year) <= Number.parseInt(new Date().getFullYear().toString().substr(2))){
          return false;
        }
      }
      else{
        if(Number.parseInt(year) < Number.parseInt(new Date().getFullYear().toString().substr(2))){
          return false;
        }
      }
  
      //Verifica el limite superior del ano de vencimiento
      if(Number.parseInt(year) > (Number.parseInt(new Date().getFullYear().toString().substr(2))+15)){
          return false;
      }

      return true;
    }
  
    //Metodo que permite verificar si la TDC introducida cumple con el algoritmo de Luhm (es una tarjeta valida)
    valid_credit_card(value : any) {
      // accept only digits, dashes or spaces
      if (/[^0-9-\s]+/.test(value)) return false;
  
      // The Luhn Algorithm. It's so pretty.
      var nCheck = 0, nDigit = 0, bEven = false;
      value = value.replace(/\D/g, "");
  
      for (var n = value.length - 1; n >= 0; n--) {
        var cDigit = value.charAt(n),
          nDigit = parseInt(cDigit, 10);
  
        if (bEven) {
          if ((nDigit *= 2) > 9) nDigit -= 9;
        }
  
        nCheck += nDigit;
        bEven = !bEven;
      }
  
      return (nCheck % 10) == 0;
    }

    deleteItem(row : any) {
      if (!this.canManageCreditCards()) {
        this.toast.showWarning('No tienes permisos para gestionar tarjetas.');
        return;
      }

      this.confirmService.confirm({title: this.translate.instant('customerPlans.confirmTitle'), message: this.translate.instant('customerCards.confirmDelete')})
        .subscribe(res => {
          if (res) {
            this.deletes(row);
          }
        })
    }

    deletes(tdc : any){
      if (!this.canManageCreditCards()) {
        this.toast.showWarning('No tienes permisos para gestionar tarjetas.');
        return;
      }

      console.log(tdc);

      this.spinner.open();
      if (!tdc.corerId) {
        this.spinner.close();
        return this.toast.showInfo(this.translate.instant('customerCards.cannotChangeStatus'));
      }

      const action = tdc.statusInCorer === 1 ? 'delete' : 'activate';
      const url = `${this.webService.HOST}/customer/${this.IDcustomer}/creditcard/${tdc.corerId}/${action}`;
      const json = { token: tdc.token_creditCardToken };
      console.log(json);
      console.log(url);
      this.webService.post(json, url).subscribe(
          () => {
            this.spinner.close();
            this.toast.showSuccess(this.translate.instant('customerCards.updated'));
            window.location.reload();
          },
          () => {
            this.spinner.close();
            this.toast.showError(this.translate.instant('customerCards.cannotChangeStatusActive'));
          }
      );
    }
  
    //Metodo que permite desactivar/reactivar una tarjeta para poder ser utilizada
    cambioestado(ids : number[]){
      if (!this.canManageCreditCards()) {
        this.toast.showWarning('No tienes permisos para gestionar tarjetas.');
        return;
      }

      for(let id of ids) {
        let mask="";
        for(let i in this.tarjetas){
          if(this.tarjetas[i].creditCard.id == id){
            mask = this.tarjetas[i].creditCard.maskCreditCard;
          }
        }

        this.webService.get(this.webService.HOST + "/customer/" + this.IDcustomer + "/customerHasCreditCard/" + id).subscribe(tdc => {
          //Se guarda la descripcion del estado en la columna correspondiente
          this.webService.post( { token : tdc.result.tokenCreditCard } ,this.webService.HOST + "/customer/" + this.IDcustomer + "/creditcard/" + tdc['result'].id + "/delete").subscribe(params => {
            this.toast.showSuccess(this.translate.instant('customerCards.cardDeleted'))
            this.ngOnInit();
        }, (err) => {
            this.toast.showError(this.translate.instant('customerCards.cardNotDeleted') + " " + mask + ". " + this.translate.instant('customerCards.verifyNotAssociated'));
        });
        }, (err) => this.toast.showError(err) );
      }
    }

    goBack(){
      this.router.navigate(["/reports"]); 
    }

    /** MM/AA a partir de expiration_month y expiration_year (2 dígitos, o 4 si viniera completo). */
    formatExpiration(month: any, year: any): string {
      return formatCardExpiration(month, year);
    }

    /** Segunda línea de la dirección: "Ciudad, PAÍS CP" (city, country zipCode), omitiendo vacíos. */
    formatAddressDetail(address: BillingAddress | null | undefined): string {
      return address ? formatAddressDetail(address) : '';
    }

    canManageCreditCards(): boolean {
      return this.userPermissionsService.hasPermission('controllers.CreditCards.generateCreditcardToken');
    }

    canSetBillingAddress(): boolean {
      return this.userPermissionsService.hasPermission('controllers.CreditCards.setBillingAddress');
    }

    /** Pantalla de dirección de facturación; usa la PK de la tarjeta (id), no corerId. */
    goToBillingAddress(card: any): void {
      if (!this.canSetBillingAddress()) {
        return;
      }
      this.router.navigate(['reports', this.IDcustomer, 'cards', card.id, 'billing']);
    }
    


}
